import React, { useMemo, useRef, useState } from 'react';
import { FormGroup, Label } from 'reactstrap';
import { Formik, Form, Field } from 'formik';
import { CustomFormRadioGroup } from './customComponent';
import { ButtonWithLoadingIcon } from '../../../components/common/ButtonWithLoadingIcon';
import * as Yup from 'yup';
import { LinkButton } from '../../../components/common/LinkButton';

const formValidations = {
  wear_occassion: Yup.string().required(
    'Please select what occasion did you rent this item for'
  ),
  // wear_frequency: Yup.string().required(
  //   'Please select how many times did you wear this item'
  // ),
  // fit: Yup.string().required('Please select value'),
  fit_review: Yup.string().required('Please select value'),
};

const FormRowScaffold = ({
  label,
  id,
  showError,
  error,
  children,
  fieldDescription = '',
  ...other
}) => {
  return (
    <FormGroup>
      <Label for={id} {...other} style={{ fontFamily: 'Brown Bold' }}>
        {label}
      </Label>
      <div style={{ flexDirection: 'column', display: 'flex' }}>
        {children}
        {showError && (
          <div
            className='invalid-feedback d-block'
            style={{ fontFamily: 'Brown' }}
          >
            {error}
          </div>
        )}

        {fieldDescription && (
          <small className='text-muted mb-2 mt-2 d-block'>
            {fieldDescription}
          </small>
        )}
      </div>
    </FormGroup>
  );
};

const SelectFormRow = ({
  label,
  name,
  id,
  options,
  showError,
  error,
  showEmpty,
  ...otherProps
}) => {
  return (
    <FormRowScaffold
      label={label}
      id={id}
      {...otherProps}
      showError={showError}
      error={error}
    >
      <Field as='select' name={name} id={id} className='form-control'>
        {showEmpty && <option value=''>Select</option>}
        {options.map((opt, index) => (
          <option value={opt.value} key={`${name}_${index}`}>
            {opt.label ? opt.label : opt.display}
          </option>
        ))}
      </Field>
    </FormRowScaffold>
  );
};

const FIT_OPTIONS = [
  { key: 0, label: 'Yes', value: true },
  { key: 1, label: 'No', value: false },
];

const SIZE_OPTIONS = [
  { key: 0, label: 'Small', value: 1 },
  { key: 1, label: 'True to size', value: 2 },
  { key: 2, label: 'Large', value: 3 },
];

export const ReviewModalStep2 = ({
  productData,
  onPressButton,
  onPrevious,
  wearOccassionsData,
  wearFrequenciesData,
  wearOccassionValue,
  wearFrequencyValue,
  fitValue,
  fitReviewValue,
}) => {
  const formikRef = useRef();
  const [errorText, setErrorText] = useState(null);
  const initialValues = {
    wear_occassion: productData.wear_occassion || wearOccassionValue,
    // wear_frequency: productData.wear_frequency || wearFrequencyValue,
    // fit: productData.fit || fitValue || '',
    fit_review: productData.fit_review || fitReviewValue || '',
  };

  const getProductValidationSchema = () => {
    return Yup.object().shape({
      ...formValidations,
    });
  };

  const reviewSchema = useMemo(() => getProductValidationSchema(), []);

  const handleSubmit = () => {
    if (formikRef && formikRef.current && formikRef.current.values) {
      setErrorText(null);
      const data = {
        ...formikRef.current.values,
      };
      onPressButton(data);
    } else {
      onPressButton();
    }
  };

  const renderButtons = () => {
    return (
      <div
        className={'review-button'}
        style={{
          border: 'none',
        }}
      >
        <ButtonWithLoadingIcon
          style={{
            alignSelf: 'flex-start',
            width: '100%',
            marginBottom: 10,
          }}
          type='submit'
          color={'primary'}
          onClick={() => handleSubmit()}
        >
          Next
        </ButtonWithLoadingIcon>
        <LinkButton
          className={'mt-3'}
          style={{
            marginBottom: 10,
            textAlign: 'center',
            width: '100%',
            height: 55,
            cursor: 'pointer',
          }}
          onClick={() => onPrevious(formikRef?.current?.values)}
        >
          Previous
        </LinkButton>
      </div>
    );
  };

  const isFormValid = (errors, touched) => {
    return (
      // (errors.wear_frequency && touched.wear_frequency) ||
      (errors.wear_occassion && touched.wear_occassion) ||
      // (errors.fit && touched.fit) ||
      (errors.fit_review && touched.fit_review)
    );
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        innerRef={formikRef}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={reviewSchema}
      >
        {({
          values,
          errors,
          isSubmitting,
          touched,
          setFieldValue,
          setFieldTouched,
        }) => {
          const isError = isFormValid(errors, touched);
          return (
            <Form className='mb-4'>
              <div
                style={{
                  paddingLeft: '2.5rem',
                  paddingRight: '2.5rem',
                  paddingTop: 25,
                }}
              >
                <div style={{ marginBottom: 30 }}>
                  <SelectFormRow
                    label='What occasion did you rent this item for?'
                    name='wear_occassion'
                    id='wear_occassion'
                    options={wearOccassionsData || []}
                    showError={
                      (errors.wear_occassion && touched.wear_occassion) ||
                      isError
                    }
                    onBlur={setFieldTouched}
                    error={errors.wear_occassion}
                    showEmpty
                  />
                </div>

                {/* <div style={{ marginBottom: 30 }}>
                  <SelectFormRow
                    label='How many times did you wear this item?'
                    name='wear_frequency'
                    id='wear_frequency'
                    options={wearFrequenciesData || []}
                    showError={errors.wear_frequency && touched.wear_frequency}
                    error={errors.wear_frequency}
                    onBlur={setFieldTouched}
                    showEmpty
                  />
                </div>

                <div style={{ marginBottom: 30 }}>
                  <span
                    style={{
                      fontFamily: 'Brown Bold',
                      marginBottom: 5,
                    }}
                  >
                    Did it fit?
                  </span>
                  <div style={{ marginTop: 8 }}>
                    <CustomFormRadioGroup
                      name='fit'
                      value={values.fit}
                      id='fit'
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      showError={errors.fit && touched.fit}
                      error={errors.fit}
                      options={FIT_OPTIONS}
                      notInline
                    />
                  </div>
                </div> */}

                <div style={{ marginBottom: 30 }}>
                  <span
                    style={{
                      fontFamily: 'Brown Bold',
                    }}
                  >
                    How did the sizing run?
                  </span>
                  <div style={{ marginTop: 8 }}>
                    <CustomFormRadioGroup
                      name='fit_review'
                      value={values.fit_review}
                      id='fit_review'
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      showError={errors.fit_review && touched.fit_review}
                      error={errors.fit_review}
                      options={SIZE_OPTIONS}
                      notInline
                    />
                  </div>
                </div>

                {isError ? (
                  <div style={{ display: 'flex' }}>
                    <span
                      style={{
                        fontSize: '1rem',
                        color: '#F96E4E',
                        fontFamily: 'Brown',
                        width: '100%',
                        textAlign: 'center',
                      }}
                    >
                      {'Please fix the errors above'}
                    </span>
                  </div>
                ) : null}
              </div>
              {renderButtons()}
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
